import Icon from '../components/Icon.vue'

Icon.register({
  'microphone-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1c7 5.4 8.2 15.5 2.8 22.5l-19.6 25.3c-5.4 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.5-2.8-22.5l19.6-25.3c5.4-7 15.5-8.2 22.5-2.8l178.5 138v-45.4c0-53 43-96 96-96 53 0 96 43 96 96v160c0 10.5-2.2 20.3-5.3 29.7l26.5 20.5c6.8-15.4 10.7-32.3 10.7-50.2v-48c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48c0 29-7.4 56.1-20 80.1zM400 464c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-160c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h56v-34.2c-88-12.1-152-92-152-181.7v-6.9l52 40.2c12.4 53.2 55.3 96.4 111.2 101.8 6.9 0.7 13.6 0.2 20.3-0.2l50.1 38.7c-10.8 3.8-22 6.7-33.7 8.3v33.8h56z'
      }
    ]
  }
})
